import { apiClient } from '@/shared/api';
import {
  UserGroupCreateRequest,
  UserGroupCreateResponse,
  UserGroupDetailResponse,
  UserGroupListResponse,
  UserGroupUpdateRequest,
  UserGroupUpdateResponse,
} from './types';

/**
 * Fetch user groups list with pagination per OpenAPI GET /user-group
 */
export const fetchUserGroups = async (params?: { limit?: number; offset?: number; isDeleted?: boolean }) => {
  const { data } = await apiClient.get<UserGroupListResponse>('/user-group', { params });
  return data;
};

/**
 * Fetch a user group by ID per OpenAPI GET /user-group/{group_id}
 */
export const fetchUserGroupById = async (groupId: number) => {
  const { data } = await apiClient.get<UserGroupDetailResponse>(`/user-group/${groupId}`);
  return data;
};

/**
 * Create a user group per OpenAPI POST /user-group
 */
export const createUserGroup = async (body: UserGroupCreateRequest) => {
  const { data } = await apiClient.post<UserGroupCreateResponse>('/user-group', body);
  return data;
};

/**
 * Update a user group per OpenAPI PUT /user-group/{group_id}
 */
export const updateUserGroup = async ({ id, body }: { id: number; body: UserGroupUpdateRequest }) => {
  const { data } = await apiClient.put<UserGroupUpdateResponse>(`/user-group/${id}`, body);
  return data;
};

/**
 * Delete a user group per OpenAPI DELETE /user-group/{group_id}
 */
export const deleteUserGroup = async (id: number) => {
  await apiClient.delete(`/user-group/${id}`);
};
